import React from "react";
import "./GpExperience.css";
import GpHero from "../../components/GpHero/GpHero";
import GpImageContainer from "../../components/GpImageContainer/GpImageContainer"

const GpExperience = ({ setNavbarBg }) => {
  return (
    <div>
      
      <GpHero setNavbarBg={setNavbarBg} />
      <GpImageContainer/>
    </div>
  );
};
export default GpExperience;
